import * as React from 'react';
import { TileView, EditableComponentProps, ComplexValue } from 'ui';
import {
  SetValuesFromResultType
} from 'app/area/case/features/search-external-provider/types';
import styles from './search-external-provider.scss';
import { SearchResultItem } from 'app/area/case/components/search-external-provider/search-result-item';
import { SearchExternalResultValue } from 'app/area/case/types-store';

interface SearchResultListProps extends EditableComponentProps<ComplexValue<string>> {
  results: SearchExternalResultValue[][];
  setValuesFromResult: SetValuesFromResultType;
  textConfirmSelection?: string;
  textFailedToMapCodeValue?: string;
  textItemNotFound?: string;
}

export const SearchResultList = ({
  results,
  setValuesFromResult,
  textConfirmSelection,
  textItemNotFound,
  textFailedToMapCodeValue,
  componentId,
  className
}: SearchResultListProps) => results && results.length ? (
    <TileView>
      {results.map((result, i) => (
        <SearchResultItem
          key={i}
          values={result}
          setValuesFromResult={setValuesFromResult}
          textConfirmSelection={textConfirmSelection}
          textFailedToMapCodeValue={textFailedToMapCodeValue}

          componentId={componentId}
          className={className}
          onChange={undefined}
        />
      ))}
    </TileView>
  ) : (
    <div className={styles.warningMessage}>{textItemNotFound}</div>
  );
